import React from 'react';

const LOGO_URL =
  'https://customer-assets-agu9un31.emergentagent.net/job_hybrid-app-test/artifacts/tr1ramof_d66f75ef-a46a-41a2-bfd8-ac219aef64a9.png';

/**
 * ChainKart logo lockup.
 * `size` controls the effective visual height in pixels.
 * We crop the surrounding black padding in the source PNG using object-fit + clip.
 * Aspect ratio of the visible glyph inside the source is ~ 5.5 : 1
 */
const BrandLogo = ({ size = 32, className = '' }) => {
  const height = `${size}px`;
  const width = `${size * 5.5}px`; // matches visible glyph aspect

  return (
    <div
      className={`inline-block relative overflow-hidden select-none ${className}`}
      style={{ height, width }}
      aria-label="ChainKart"
      role="img"
    >
      <img
        src={LOGO_URL}
        alt="ChainKart"
        draggable={false}
        // Scale up so the interior glyph fills the container, hiding the padding.
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) scale(1.9)',
          height: '100%',
          width: 'auto',
          objectFit: 'cover',
          pointerEvents: 'none',
        }}
      />
    </div>
  );
};

export default BrandLogo;
